import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "../../../../../common/services/api-client.service";
import { ITradslagsdataResponse } from "./arbetsorder-tradslagsdata.models";

@Injectable({
    providedIn: "root"
})
export class ArbetsorderTradslagsdataService {
    private readonly apiClient = inject(ApiClientService);

    getTradslagsdataForArbetsorder(id: number): Observable<ITradslagsdataResponse> {
        return this.apiClient.get<ITradslagsdataResponse>(`tradslagsdata/arbetsorder/${id}`);
    }

    getTradslagsdataForAtgard(id: number): Observable<ITradslagsdataResponse> {
        return this.apiClient.get<ITradslagsdataResponse>(`tradslagsdata/atgard/${id}`);
    }
}
